import WFSLayer from '@arcgis/core/layers/WFSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';
import { parseWfsServiceUrl } from './parseWfsServiceUrl';

export const wfsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wfs;
  },

  async load(service) {
    const adminOpacity = resolveAdminOpacity(service);
    const {
      url,
      customParameters,
      featureTypeName: urlFeatureType,
    } = parseWfsServiceUrl(service.gis_service_url);

    // Prefer admin-configured feature type; fall back to typename from a
    // pasted GetFeature URL.
    const featureTypeName =
      service?.attributes?.sublayers?.[0] || urlFeatureType || '';

    const layer = new WFSLayer({
      url,
      id: service.gisLayerID,
      name: featureTypeName,
      visible: false,
      ...(customParameters ? { customParameters } : {}),
      ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
    });

    await layer.load();

    return ensureLoadedLayerArray(layer);
  },
};
